export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const _LOADING = 'LOADING';
export const FETCH_USER = 'FETCH_USER';
export const GET_EXAM_CANDIDATES = 'GET_EXAM_CANDIDTAES';
export const CREATE_CANDIDATE = 'CREATE_CANDIDATE';
export const GET_CANDIDATE = 'GET_CANDIDATE';
export const GET_CANDIDATES = 'GET_CANDIDATES'; 
export const EDIT_CANDIDATE = 'EDIT_CANDIDATE';
export const DELETE_CANDIDATE = 'DELETE_CANDIDATE';
export const GET_CURRENT_SUBJECT = 'GET_CURRENT_SUBJECT';
export const SET_CURRENT_SUBJECT = 'SET_CURRENT_SUBJECT';
export const CREATE_EXAM = 'CREATE_EXAM';
export const GET_ACTIVE_EXAM = 'GET_ACTIVE_EXAM';
export const GET_EXAM = 'GET_EXAM';
export const GET_EXAMS = 'GET_EXAMS'; 
export const EDIT_EXAM = 'EDIT_EXAM';
export const DELETE_EXAM = 'DELETE_EXAM';

export const GET_DCANDIDATE = 'GET_DCANDIDATE';
export const DISPLAY_ERROR = 'DISPLAY_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';